// Module
var code = "<template> <require from=\"app/cm/admin/referral/referred-to\"></require> <referred-to></referred-to> </template> ";
// Exports
module.exports = code;